import { FC } from "react";
import { observer } from "mobx-react-lite";
import { Row, Col } from "antd";
import { useHandleForm } from "../../../hooks/useHandleForm";
import {
  FormBlock,
  FormField,
  IButton,
} from "../../../ui-kit";
import DictionariesStore from "../../../store/dictionary";

import styles from "../styles.module.scss";

const CustomDictionaryEditForm: FC = observer((values) => {

  const initialValues = {
    id: values?.record?.dictId,
    title: values?.record?.title,
    name: values?.record?.name,
    description: values?.record?.description,
    dictionaryGroupId: values?.record?.parentGroupId
  };
  const initialFocus = {};
  const {
    register,
    handleSubmit,
    watchAllField,
    isFocused,
    handleBlur,
    handleFocus,
    control,
    setValue,
  } = useHandleForm(null, initialValues, initialFocus);

  const onSubmit = (values) => {
    DictionariesStore.saveDict(values);
  };

  const lockDictionary = () => {
    DictionariesStore.lockDictionary(values?.record?.dictId);
    DictionariesStore.getDictList();
  }

  const unlockDictionary = () => {
    DictionariesStore.unlockDictionary(values?.record?.dictId);
    DictionariesStore.getDictList();
  }

  
  return (
    <form
      className={styles.SmsSettingsParamsForm}
      onSubmit={handleSubmit(onSubmit)}
    >
      <FormBlock>
        <Row gutter={[15, 20]}>
          <Col span={8}>
            <FormField
              label="Наименование справочника"
              name="title"
              register={register}
              type="text"
              disabled={values?.record?.isDeleted}
              isFocused={isFocused.title}
              currentValue={watchAllField.title}
              onFocus={handleFocus}
              onBlur={handleBlur}
              isRequired
            />
          </Col>
          <Col span={8}>
            <FormField
              label="Описание"
              name="description"
              register={register}
              type="text"
              disabled={values?.record?.isDeleted}
              isFocused={isFocused.description}
              currentValue={watchAllField.description}
              onFocus={handleFocus}
              onBlur={handleBlur}
              isRequired
            />
          </Col>
        </Row>
        <Row gutter={[15, 20]}>
          <Col>
            <IButton className={styles.UsersButton} type="submit" disabled={values?.record?.isDeleted}>
              Сохранить
            </IButton>
          </Col>
          <Col>
            {
              values?.record?.isBlocked ?
              <IButton className={styles.UsersButton} onClick={(e) => {e.preventDefault();unlockDictionary()}}>
                Разблокировать
              </IButton> :
              <IButton className={styles.UsersButton} onClick={(e) => {e.preventDefault();lockDictionary()}}>
                Заблокировать
              </IButton>
            }
            
          </Col>
        </Row>
      </FormBlock>
    </form>
  );
});

export default CustomDictionaryEditForm;
